import { useState } from 'react';

type ProgramItem = {
  time: string;
  title: string;
  desc: string;
  speaker?: string;
  tag?: string | null;
};

// ── 16 апреля ──────────────────────────────────────────────
const day1hall1: ProgramItem[] = [
  { time: '9:00 – 9:30', title: 'Регистрация участников', desc: 'Получение бейджей, раздаточных материалов. Приветственный кофе.', tag: 'reg' },
  { time: '9:30 – 11:00', title: 'Диалоги о себе и пациентах', desc: 'Просто о сложном. Открытая дискуссия о взаимоотношениях врача и пациента, профессиональных вызовах и личном опыте.', speaker: 'Проф. Искра Д.А.', tag: null },
  { time: '11:00 – 11:15', title: 'Смехосоматика', desc: 'Миниспектакль с участием актёров проекта «Смехосоматика». Они превратят наш сложный врачебный быт в терапевтическую комедию.', tag: 'standup' },
  {
    time: '11:15 – 12:15',
    title: 'Как справиться с астенией и когнитивным дефицитом',
    desc: 'Секционное заседание. Просто о сложном.\n\nМодератор: проф. Афанасьев Василий Владимирович, Санкт-Петербург\n\n• Применение холинотропных и серотонинергических средств в лечении астенического синдрома и когнитивной дисфункции (60 мин)\nпроф. Афанасьев Василий Владимирович, Санкт-Петербург\nдоц. Пугачева Екатерина Леонидовна, Санкт-Петербург',
    tag: null,
  },
  { time: '12:15 – 12:30', title: 'Смехосоматика', desc: 'Миниспектакль с участием актёров проекта «Смехосоматика». Они превратят наш сложный врачебный быт в терапевтическую комедию.', tag: 'standup' },
  {
    time: '12:30 – 13:30',
    title: 'Новый взгляд на дегенеративно-дистрофические изменения в позвоночнике',
    desc: 'Секционное заседание.\n\nМодератор: проф. Искра Дмитрий Анатольевич, Санкт-Петербург\n\n• Энтезопатии позвоночника (60 мин)\nпроф. Искра Дмитрий Анатольевич, Санкт-Петербург\nпроф. Афанасьев Василий Владимирович, Санкт-Петербург',
    tag: null,
  },
  { time: '13:30 – 14:30', title: 'Обед + AI-болит', desc: 'Обеденный перерыв. Разговор с искусственным интеллектом — специальный медицинский чат-бот AI-болит.', tag: 'ai' },
  {
    time: '14:30 – 16:00',
    title: 'Перспективные стратегии лечения дорсалгий',
    desc: 'Секционное заседание.\n\nМодератор: проф. Каракулова Юлия Владимировна, Пермь\n\n• Модифицируем болезнь при боли в спине (30 мин)\nпроф. Ястребцева Ирина Петровна, Москва\n• Клинические примеры эффективного лечения острой и хронической боли в спине (30 мин)\nпроф. Каракулова Юлия Владимировна, Пермь\n• Метастатическое поражение оболочек мозга: диагностика и ведение пациентов (30 мин)\nпроф. Голдобин Виталий Витальевич, Санкт-Петербург',
    tag: null,
  },
  { time: '16:00 – 16:15', title: 'Смехосоматика', desc: 'Миниспектакль с участием актёров проекта «Смехосоматика». Они превратят наш сложный врачебный быт в терапевтическую комедию.', tag: 'standup' },
  {
    time: '16:15 – 17:45',
    title: 'Зависимости, психотерапевтические техники',
    desc: 'Секционное заседание. Всё, что нужно знать врачу непсихиатрического профиля.\n\nМодератор: проф. Карпов Сергей Михайлович, Ставрополь\n\n• Никотиновая ломка невроза (30 мин)\nпроф. Карпов Сергей Михайлович, Ставрополь\n• Как сохранить двигательную активность и творческое долголетие: рамка проблемы и путь решения. Мастер-класс (30 мин)\nдмн Калинский Павел Павлович, Владивосток\n• Особенности программ помощи при эмоциональном выгорании (30 мин)\nкмн Петуров Игорь Анатольевич, Санкт-Петербург',
    tag: null,
  },
  { time: '17:45 – 18:00', title: 'Смехосоматика', desc: 'Миниспектакль с участием актёров проекта «Смехосоматика». Они превратят наш сложный врачебный быт в терапевтическую комедию.', tag: 'standup' },
];

const day1hall2: ProgramItem[] = [
  {
    time: '11:15 – 12:15',
    title: 'Детская неврология',
    desc: 'Секционное заседание.\n\nМодератор: заслуженный деятель науки РФ, проф. Скрипченко Наталья Викторовна, Санкт-Петербург\n\n• Дифференциально-диагностические аспекты цереброваскулярной патологии у детей с подозрением на нейроинфекционное заболевание (30 мин)\nпроф. Скрипченко Елена Юрьевна, кмн Василева Юлия Петровна, кмн Астапова Анна Владимировна, Санкт-Петербург\n• Диагностические лабиринты в практике детского невролога (разборы трудных клинических случаев) (30 мин)\nзаслуженный деятель науки РФ, проф. Скрипченко Наталья Викторовна, дмн Иванова Галина Петровна, проф. Скрипченко Елена Юрьевна, Санкт-Петербург',
    tag: null,
  },
  { time: '12:15 – 12:30', title: 'Смехосоматика — зал «Кремлёвский»', desc: 'Миниспектакль с участием актёров проекта «Смехосоматика». Они превратят наш сложный врачебный быт в терапевтическую комедию. Проводится в зале «Кремлёвский».', tag: 'standup' },
  {
    time: '12:30 – 13:30',
    title: 'Инсульт. Что нового?',
    desc: 'Секционное заседание.\n\nМодератор: проф. Цыган Николай Васильевич, Санкт-Петербург\n\n• Нарушения глотания в остром периоде ОНМК. Как помочь пациенту? (30 мин)\nкмн Жуковская Наталья Владимировна, Санкт-Петербург\n• Острая ишемия мозга: современная концепция патогенеза, особенности патогенетической терапии и профилактики (30 мин)\nпроф. Цыган Николай Васильевич, член-кор. РАН, проф. Одинак Мирослав Михайлович, проф. Литвиненко Игорь Вячеславович, Санкт-Петербург',
    tag: null,
  },
  { time: '13:30 – 14:30', title: 'Обед + AI-болит', desc: 'Обеденный перерыв. Разговор с искусственным интеллектом — специальный медицинский чат-бот AI-болит.', tag: 'ai' },
  {
    time: '14:30 – 16:00',
    title: 'Правила лечения и профилактики от ИИ и клинического фармаколога',
    desc: 'Секционное заседание.\n\nМодератор: проф. Афанасьев Василий Владимирович, Санкт-Петербург\n\n• Искусственный интеллект в профилактике острого инсульта и сосудистых когнитивных нарушений (30 мин)\nпроф. Каракулова Юлия Владимировна, Пермь\n• Правила комбинирования лекарственных веществ при многокомпонентной терапии у коморбидного больного (30 мин)\nпроф. Афанасьев Василий Владимирович, Санкт-Петербург\n• Расчет рисков при многокомпонентной терапии у коморбидного больного (30 мин)\nдоц. Пугачева Екатерина Леонидовна, Санкт-Петербург',
    tag: 'ai',
  },
  { time: '16:00 – 16:15', title: 'Смехосоматика — зал «Кремлёвский»', desc: 'Миниспектакль с участием актёров проекта «Смехосоматика». Они превратят наш сложный врачебный быт в терапевтическую комедию. Проводится в зале «Кремлёвский».', tag: 'standup' },
];

// ── 17 апреля ──────────────────────────────────────────────
const day2hall1: ProgramItem[] = [
  { time: '9:30 – 10:00', title: 'Регистрация участников', desc: 'Получение бейджей, раздаточных материалов. Приветственный кофе.', tag: 'reg' },
  {
    time: '10:00 – 11:00',
    title: 'Сложные пациенты, новые стратегии',
    desc: 'Секционное заседание.\n\nМодератор: проф. Клочева Елена Георгиевна, Санкт-Петербург\n\n• Контролируя мигрень: от немедленного ответа к профилактике. Место таргетной терапии антагонистами CGRP-рецепторов (30 мин)\nпроф. Амелин Александр Витальевич, Санкт-Петербург\n• Простой выбор антикоагулянта при сложной задаче у пациента с фибрилляцией предсердий (30 мин)\nпроф. Клочева Елена Георгиевна, Санкт-Петербург',
    tag: null,
  },
  {
    time: '11:00 – 12:00',
    title: 'Ботулинотерапия в лечении хронической мигрени и коморбидной патологии',
    desc: 'Мастер-класс.\n\nдоц. Коваленко Александр Павлович, Санкт-Петербург',
    tag: 'workshop',
  },
  { time: '12:00 – 12:15', title: 'Смехосоматика', desc: 'Миниспектакль с участием актёров проекта «Смехосоматика». Они превратят наш сложный врачебный быт в терапевтическую комедию.', tag: 'standup' },
  {
    time: '12:15 – 13:45',
    title: 'Периферическая нервная система — новые реалии',
    desc: 'Секционное заседание.\n\nМодератор: проф. Заславский Леонид Григорьевич, Санкт-Петербург\n\n• Невропатия мелких волокон: современное состояние проблемы (30 мин)\nпроф. Заславский Леонид Григорьевич, Скорнякова Евгения Алексеевна, Санкт-Петербург\n• Современная лабораторная диагностика полинейропатий: показатели и алгоритмы (30 мин)\nкмн Лапин Сергей Владимирович, Санкт-Петербург\n• Молекулярно-генетическая диагностика нейромышечных заболеваний: использование NGS секвенирования в рутинной клинической практике (30 мин)\nкмн Назаров Владимир Дмитриевич, Санкт-Петербург',
    tag: null,
  },
  {
    time: '13:45 – 15:45',
    title: 'Важные советы практикующим врачам',
    desc: 'Секционное заседание.\n\nМодератор: дмн Генералов Василий Олегович, Москва\n\n• Тактика лечения резистентной эпилепсии, достижение ремиссии и отмены противосудорожной терапии (30 мин)\nдмн Генералов Василий Олегович, Москва\n• Калейдоскоп по умеренным когнитивным нарушениям с вариантами терапии (30 мин)\nдоц. Эмануэль Юлия Владимировна, Санкт-Петербург\n• Инновационные технологии в работе медицинского логопеда (30 мин)\nдоц. Балашова Ирина Николаевна, Санкт-Петербург\n• Тревога в изобразительном искусстве\nпроф. Рачин Андрей Петрович, Москва',
    tag: null,
  },
  { time: '15:45 – 16:30', title: 'Торжественное закрытие + фуршет', desc: 'Торжественное закрытие конференции. Дружеский фуршет, неформальное общение и кулуары.', tag: 'party' },
];

const day2hall2: ProgramItem[] = [];

const tagColors: Record<string, string> = {
  standup: 'bg-[#c8963e]/10 text-[#c8963e] border border-[#c8963e]/20',
  ai: 'bg-[#1a6b5a]/10 text-[#1a6b5a] border border-[#1a6b5a]/20',
  party: 'bg-[#0f3d32]/10 text-[#0f3d32] border border-[#0f3d32]/20',
  workshop: 'bg-[#7c3d12]/10 text-[#7c3d12] border border-[#7c3d12]/20',
  reg: 'bg-gray-100 text-gray-500 border border-gray-200',
};

const tagLabels: Record<string, string> = {
  standup: '😄 медицинский юмор',
  ai: '🤖 AI',
  party: '🥂 фуршет',
  workshop: '🔬 мастер-класс',
  reg: '📋 регистрация',
};

function Timeline({ items }: { items: ProgramItem[] }) {
  return (
    <div className="relative">
      <div className="absolute left-[5.5rem] top-0 bottom-0 w-0.5 bg-[#c8963e]/25 hidden md:block" />
      <div className="space-y-3">
        {items.map((item, i) => (
          <div key={i} className="flex gap-4 md:gap-6 items-start">
            {/* Time */}
            <div className="hidden md:flex w-20 shrink-0 justify-end pt-3">
              <span className="text-xs font-bold text-[#0f3d32] bg-white border border-[#c8963e]/30 rounded-full px-2 py-1 text-center leading-tight whitespace-nowrap">
                {item.time}
              </span>
            </div>
            {/* Dot */}
            <div className="hidden md:flex w-4 shrink-0 justify-center mt-4">
              <div className={`w-3 h-3 rounded-full border-2 ${
                item.tag === 'standup' ? 'bg-[#c8963e] border-[#c8963e]'
                : item.tag === 'ai' ? 'bg-[#1a6b5a] border-[#1a6b5a]'
                : item.tag === 'party' ? 'bg-[#0f3d32] border-[#0f3d32]'
                : item.tag === 'workshop' ? 'bg-[#7c3d12] border-[#7c3d12]'
                : item.tag === 'reg' ? 'bg-gray-300 border-gray-300'
                : 'bg-white border-[#0f3d32]/30'
              }`} />
            </div>
            {/* Card */}
            <div className={`flex-1 rounded-xl p-4 border ${
              item.tag === 'reg' ? 'bg-gray-50 border-gray-100'
              : item.tag === 'standup' ? 'bg-[#fffbf4] border-[#c8963e]/15'
              : item.tag === 'ai' ? 'bg-[#f0faf7] border-[#1a6b5a]/15'
              : item.tag === 'party' ? 'bg-[#f0f7f4] border-[#0f3d32]/15'
              : item.tag === 'workshop' ? 'bg-[#fdf6f0] border-[#7c3d12]/15'
              : 'bg-white border-gray-100'
            }`}>
              <div className="flex flex-wrap items-start justify-between gap-2">
                <div className="flex-1 min-w-0">
                  <div className="md:hidden text-xs font-bold text-[#c8963e] mb-1">{item.time}</div>
                  <h4 className="font-bold text-[#0f3d32] text-sm md:text-base leading-snug">{item.title}</h4>
                  {item.speaker && (
                    <div className="text-xs text-[#c8963e] font-semibold mt-0.5">{item.speaker}</div>
                  )}
                  {item.tag !== 'reg' && item.desc && (
                    <p className="text-gray-500 text-xs md:text-sm mt-1 leading-relaxed whitespace-pre-line">{item.desc}</p>
                  )}
                </div>
                {item.tag && (
                  <span className={`text-xs font-semibold px-2.5 py-1 rounded-full shrink-0 ${tagColors[item.tag]}`}>
                    {tagLabels[item.tag]}
                  </span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function ProgramSection() {
  const [activeDay, setActiveDay] = useState<1 | 2>(1);
  const [activeHall, setActiveHall] = useState<1 | 2>(1);

  const isDay1 = activeDay === 1;

  const items = isDay1
    ? (activeHall === 1 ? day1hall1 : day1hall2)
    : day2hall1;

  const hallLabel = isDay1
    ? (activeHall === 1 ? 'Зал «Кремлёвский»' : 'Зал «Белые ночи»')
    : 'Зал «Кремлёвский»';

  return (
    <section id="program" className="py-20 md:py-28 bg-[#f5f2ed]">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-extrabold text-[#0f3d32] mb-4">
            Программа: 2 дня, 2 зала,<br />диалоги + стендап
          </h2>
          <p className="text-gray-500 text-lg">Насыщенная программа с паузами для смеха и живого общения</p>
        </div>

        {/* Day switcher */}
        <div className="flex justify-center mb-6">
          <div className="flex bg-white rounded-full p-1 gap-1">
            {([1, 2] as const).map((day) => (
              <button
                key={day}
                onClick={() => { setActiveDay(day); setActiveHall(1); }}
                className={`px-8 py-3 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
                  activeDay === day
                    ? 'bg-[#0f3d32] text-white'
                    : 'text-gray-500 hover:text-[#0f3d32]'
                }`}
              >
                {day === 1 ? '16 апреля' : '17 апреля'}
              </button>
            ))}
          </div>
        </div>

        {/* Hall switcher — только для 16 апреля */}
        {isDay1 && (
          <div className="flex justify-center mb-10">
            <div className="flex bg-white rounded-full p-1 gap-1 border border-[#c8963e]/20">
              {([1, 2] as const).map((hall) => (
                <button
                  key={hall}
                  onClick={() => setActiveHall(hall)}
                  className={`px-6 py-2 rounded-full font-semibold text-sm transition-all cursor-pointer whitespace-nowrap ${
                    activeHall === hall
                      ? 'bg-[#c8963e] text-white'
                      : 'text-gray-500 hover:text-[#c8963e]'
                  }`}
                >
                  <i className={`${hall === 1 ? 'ri-building-line' : 'ri-building-2-line'} mr-1.5`}></i>
                  {hall === 1 ? 'Кремлёвский' : 'Белые ночи'}
                </button>
              ))}
            </div>
          </div>
        )}

        {/* Hall label */}
        <div className={`flex items-center gap-3 ${isDay1 ? 'mb-6' : 'mb-10 mt-4'}`}>
          <div className="h-px flex-1 bg-[#c8963e]/20" />
          <span className="text-sm font-bold text-[#c8963e] uppercase tracking-widest">
            {hallLabel}
          </span>
          <div className="h-px flex-1 bg-[#c8963e]/20" />
        </div>

        {/* Timeline */}
        <Timeline items={items} />

        {/* Legend */}
        <div className="flex flex-wrap gap-3 justify-center mt-10">
          {Object.entries(tagLabels).map(([key, label]) => (
            <span key={key} className={`text-xs font-semibold px-3 py-1 rounded-full ${tagColors[key]}`}>
              {label}
            </span>
          ))}
        </div>

        {/* PDF buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
          <a
            href="/program16.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 border-2 border-[#0f3d32] text-[#0f3d32] font-semibold px-8 py-3 rounded-full hover:bg-[#0f3d32] hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-download-line"></i>
            Программа 16.04 (PDF)
          </a>
          <a
            href="/program17.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 border-2 border-[#0f3d32] text-[#0f3d32] font-semibold px-8 py-3 rounded-full hover:bg-[#0f3d32] hover:text-white transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-download-line"></i>
            Программа 17.04 (PDF)
          </a>
        </div>
      </div>
    </section>
  );
}
